export default {
  en: {
    'victories': 'victories',
    'sell_player': 'sell player',
    'buy_player': 'buy player',
    'achievement_completed': 'achievement completed',
    '': '',
  }
};
